import { Heading } from '@restworld/ui-ds-base';

export const ModalHeader = ({ children, className }: { children?: React.ReactNode; className?: string }) => {
  return (
    <div className={className}>
      <Heading size={2} align="center" className="hidden lg:block">
        {children}
      </Heading>
      <Heading size={3} align="center" className="lg:hidden">
        {children}
      </Heading>
    </div>
  );
};

export const ModalSubHeader = ({ children, className }: { children?: React.ReactNode; className?: string }) => (
  <Heading size={5} align="center" color="muted" className={className}>
    {children}
  </Heading>
);
